export default __webpack_public_path__ + "static/logo-77ab33c04ef5f3128f3950ee8f3176ba.png";